/**
 * created by hgq
 * 组图发布（本地上传）
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import UploadWall from "../../../../../components/upload/UploadWall";
import {PIC_TYPE} from "../../../../../constants";
import {Scrollbars} from "react-custom-scrollbars";
import {Button, message, Modal} from "antd";
import BaseComponent from "../../../../../base/BaseComponent";
import {DetailDialog as Picture} from "../../../../resource/view/dialog/picture/picture";

class ImagesLocally extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            fileLength: '',
            pictureSize: '',
            imgWidth: 1,
            imgMargin: 0,
            fileList: [],
            previewVisible:false,
            firstShow: true,// 第一次进入页面
            newPicType:['jpg','jpeg', 'gif', 'png', 'bmp', "webp", "webp2", "tiff", "exif", "tif"],
        };
    }

    componentDidMount() {

    }

    render() {
        return (
            <Scrollbars style={{height: 343}}>
                <Modal
                    maskClosable={false}
                    keyboard={true}
                    visible={this.state.previewVisible}
                    footer={null}
                    onCancel={() => this.setState({ previewVisible: false })}>
                        <div style={{padding:12}}>
                            {
                                <img style={{ width: '100%' }} src={this.state.previewImage} />
                            }
                        </div>
                </Modal>
                {this.upload("")}
                <Picture ref={ref => this.detailDialog = ref} path={this.state.previewImage} />
            </Scrollbars>
        );
    }

    upload(listType) {
        const {fileList} = this.state;
        const accept = Array.isArray( this.props.accept) ?  "."+[...this.props.accept].join(",.") :  "."+this.state.newPicType.join(",.")
        return (
            <UploadWall
                accept={accept}
                action="/storage/uploadFile"
                multiple={true}
                listType={listType}
                fileList={fileList}
                style={{padding:'unset',paddingTop:16}}
                uploadBtnName={"点击上传"}
                beforeUpload={this.beforeUpload}
                onChange={this.onChange}
                onPreview={this.handlePreview}
                onRemove={this.handleRemove}
            />
        )
    }

    beforeUpload = async file => {
        const acceptList =  Array.isArray( this.props.accept) ? [...this.props.accept,...this.props.accept.toUpperCase()] :  [...this.state.newPicType,...this.state.newPicType.toUpperCase()];
        let newPicTypeList = [...acceptList]
        let res = newPicTypeList.find(item=>file.name.endsWith(item));
        return new Promise((resolve, reject) => {
            if(res){
                resolve(file);
            }else{
                message.error(`暂不支持该文件类型！`);
                reject();
            }
        });
    };

    onChange = (info) => {
        info.fileList = info.fileList.map(item => {
            // 取决于需要什么数据填入fileList
            if (item.uid === info.file.uid) {
                if(info.file.response && info.file.response.data){
                    //分片上传是走的自己封装的接口 所以返回值只有data
                    //直接上传走的是antd的接口，所以返回值还有一个data属性包裹着的。这里主要是兼容两种返回值
                    info.file.response = {...info.file.response.data, ...info.file.response};
                }
                item.uid = info.file.uid;
                item.ext = info.file.response && info.file.response.suffix;
                item.url = info.file.response && info.file.response.path;
                item.name = info.file.response && info.file.response.name;
                item.type = "picture";
                item.isChunk = true;
                item.status = info.file.status;
            }
            return item;
        });
        this.props.onChange(JSON.parse(JSON.stringify(info.fileList)));
        this.setState({
            fileList: info.fileList
        })
    };

    handlePreview = file => {
        if(file && file.url){
            this.setState({
                previewImage: file.url,
            },() => {
                this.detailDialog.show()
            });
        }
    };

    handleRemove =  file => {
        let fileList = this.state.fileList.filter(item => item.uid !== file.uid);
        this.props.onChange(JSON.parse(JSON.stringify(fileList)));
        this.setState({
            fileList
        });
    };
}

ImagesLocally.propTypes = {};

export default ImagesLocally;